<template>
	<div class="bg-primary">
		<div class="full-height flex-box-center position-ref flex-column">
			<div class="content text-center p-5">
				<div class="text-white text-uppercase" style="max-width: 400px">
					<div class="text-center mt-8">
						<div class="container">
							<div class="cube-container">
								<div class="cube cube1">
									<div class="box box1 front"></div>
									<div class="box box1 right"></div>
									<div class="box box1 top"></div>
									<div class="box box1 bottom"></div>
									<div class="box box1 left"></div>
									<div class="box box1 back"></div>
								</div>
							</div>
						</div>
						<div class="h1">Loading...</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			default: "grid", // swing, chase, bounce, wave, pulse, flow, plane, circle, circle-fade, grid, fold, wander
		},
	},
};
</script>
<style lang="scss" scoped>
.container {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;

  .cube-container {
    perspective: 800px;
	display: flex;
  	justify-content: center;
  	align-items: center;
    flex-direction: column;

    .cube {
		transition: transform 2s ease-in;
		transform-style: preserve-3d;
		width: 150px;
		height: 150px;
		margin: 50px 0;

		&.cube1 {
			animation: horizontal-spin 4s infinite linear;
		}

      .box {
        width: 100%;
        height: 100%;
        position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;

        &.front {
          background: #5cca82;
          transform: translateZ((75px));
        }

        &.back {
          background: #5cca82;
          transform: translateZ(-(75px)) rotateY(180deg);
        }

        &.top {
          background: #e2ffd7;
          transform: rotateX(-90deg) translateY(-(75px));
          transform-origin: top center;
        }

        &.bottom {
          background: #e2ffd7;
          transform: rotateX(90deg) translateY((75px));
          transform-origin: bottom center;
        }

        &.left {
          background: #ff5552;
          transform: rotateY(270deg) translateX(-(75px));
          transform-origin: center left;
        }

        &.right {
          background: #ff5552;
          transform: rotateY(-270deg) translateX((75px));
          transform-origin: top right;
        }
      }
    }
  }
}

@keyframes horizontal-spin {
  from {
    transform: rotateY(0) rotateX(0);
  }
  to {
    transform: rotateY(360deg) rotateX(360deg);
  }
}

</style>